// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerPackPlaceholder__container-bfbe27 {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto-fill, 85px);
  gap: 16px 8px;
  align-items: start;
  padding: 16px;
  overflow: auto;
}

.StickerPackPlaceholder__header-f80241 {
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0 4px 0 8px;
}

.StickerPackPlaceholder__footer-dde1ec {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  height: 72px;
  width: 100%;
  background-color: var(--base-10);
  padding: 0 25px;
  box-sizing: border-box;
}

.StickerPackPlaceholder__sticker-becd4b {
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/StickerPackPlaceholder/StickerPackPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,qCAAA;EACA,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(auto-fill, 85px);\n  gap: 16px 8px;\n  align-items: start;\n  padding: 16px;\n  overflow: auto;\n}\n\n.header {\n  flex-shrink: 0;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 4px 0 8px;\n}\n\n.footer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  height: 72px;\n  width: 100%;\n  background-color: var(--base-10);\n  padding: 0 25px;\n  box-sizing: border-box;\n}\n\n.sticker {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerPackPlaceholder__container-bfbe27`,
	"header": `StickerPackPlaceholder__header-f80241`,
	"footer": `StickerPackPlaceholder__footer-dde1ec`,
	"sticker": `StickerPackPlaceholder__sticker-becd4b`
};
module.exports = ___CSS_LOADER_EXPORT___;
